import React, { useContext } from "react";
import { UserDataContext } from "../Contexts/UserDataContext";
import { Route, Redirect } from "react-router-dom";

const DefaultRoute = ({ redirect }) => {
  const { userData } = useContext(UserDataContext);
  return <Redirect from="*" to={redirect || `/${userData.userName}/dashboard/`} />;
};

export default DefaultRoute;
